import sc from './data.json';

const arr = sc.data.map((i) => {
  const valueA = i.label;
  let childrenA = [];

  if (i.children && i.children.length) {
    childrenA = i.children.map((j) => {
      const valueB = j.label;
      let childrenB = [];

      if (j.children && j.children.length) {
        childrenB = j.children.map((k) => {
          const valueC = k.label;

          return {
            value: `${valueA}/${valueB}/${valueC}`,
            label: k.label,
          };
        });
      }

      return {
        value: `${valueA}/${valueB}`,
        label: j.label,
        children: childrenB,
      };
    });
  }
  return {
    value: valueA,
    label: i.label,
    children: childrenA,
  };
});

export default arr;
